import { render, staticRenderFns } from "./ResetPsw.vue?vue&type=template&id=1b93afe8&scoped=true"
import script from "./ResetPsw.vue?vue&type=script&lang=js"
export * from "./ResetPsw.vue?vue&type=script&lang=js"
import style0 from "./ResetPsw.vue?vue&type=style&index=0&id=1b93afe8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b93afe8",
  null
  
)

export default component.exports